import React, { useState, useEffect } from 'react'
import { Row, Col, Space, Button, Divider, Input, Tooltip, Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import {
  updateAddNotes,
  addAttachment,
  deleteAttachment,
  updateDeletedFiles
} from '../../reducer/notesAttachment/notesAttachmentSlice'
import Vector_20 from '../../Assets/Icons/Vector_20.svg'
import { setIsScenarioChangesDetectedFlag } from '../../reducer/CommonSlice'
import {
  notesApi,
  attachmentApi,
  getAttachmentApi,
  getNotesApi
} from '../../services/notesAttachment'
import { useMutation } from 'react-query'
import './NotesAttachment.scss'
import { DeleteOutlined, DownloadOutlined, EditOutlined } from '@ant-design/icons'
import axios from 'axios'
import { useGlobalNotification } from '../../utils/notificationProvider'

const NotesAttachment = () => {
  const dispatch = useDispatch()
  const scenarioType = useSelector((state) => state.Common.scenarioType)
  const [saveAttachment, setSaveAttachment] = useState(false)
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [deleteNotesVisible, setDeleteNotesModalVisible] = useState(false)
  const { TextArea } = Input

  const [enableTextArea, setEnableTextArea] = useState(false)
  const [notesData, setNotesData] = useState('')
  const [notesSaved, setNotesSaved] = useState(false)

  const pushNotification = useGlobalNotification()

  const [enableEditButton, SetEnableEditButton] = useState(false)
  const [enableAttachmentSaveButton, setEnableAttachmentSaveButton] = useState(false)
  const [indexx, setIndexx] = useState()
  const [deletefile, setDeleteFile] = useState('')
  const dataSourceForScenario = useSelector((state) => state.Common.dataSourceForScenario)
  const scenarioStatus = useSelector((state) => state.Common.scenarioStatus)
  const addNotes = useSelector((state) => state.NotesAttachment?.AddNotes || '')
  const attachments = useSelector((state) => state.NotesAttachment?.Attachments || [])

  const [saved, setsaved] = useState([])
  const interimScenarioId = useSelector((state) => state.Common.interim_scenario_id)

  const {
    // isError: isNotesError,
    // isLoading: isNotesLoading,
    // data: notesApiData,
    mutate: mutateNotesData
  } = useMutation(notesApi)

  const {
    // isError: isAttachmentError,
    // isLoading: isAttachmentLoading,
    // data: attachmentApiData,
    mutate: mutateAttachmentData
  } = useMutation(attachmentApi)
  const {
    isError: isAttachmentDataError,
    isLoading: isAttachmentDadaLoading,
    data: getAttachmentApiData,
    mutate: mutateGetAttachmentApi
  } = useMutation(getAttachmentApi)

  const {
    isError: isAttachmentError,
    isLoading: isNotesDataLoading,
    data: getNotesApiData,
    mutate: mutateGetNotesApi
  } = useMutation(getNotesApi)

  useEffect(() => {
    if (notesSaved) {
      mutateNotesData(
        {
          model: {
            filters: [],
            list_details: [],
            settings: { scenario_id: interimScenarioId, notes: addNotes }
          },
          user_id: sessionStorage.getItem('user_id'),
          application_role: sessionStorage.getItem('application_role')
        },
        {
          onSuccess: () => {
            dispatch(setIsScenarioChangesDetectedFlag(true))
          }
        }
      )
    }
  }, [notesSaved])

  useEffect(() => {
    mutateGetAttachmentApi({
      model: {
        filters: [],
        list_details: [],
        settings: { interim_scenario_id: interimScenarioId }
      },
      user_id: sessionStorage.getItem('user_id'),
      application_role: sessionStorage.getItem('application_role')
    })
    mutateGetNotesApi({
      model: {
        filters: [],
        list_details: [],
        settings: { scenario_id: interimScenarioId }
      },
      user_id: sessionStorage.getItem('user_id'),
      application_role: sessionStorage.getItem('application_role')
    })
  }, [interimScenarioId])

  useEffect(() => {
    if (saveAttachment) {
      const formData = new FormData()
      attachments.forEach((file) => {
        if (!file?.file_name) {
          formData.append('files', file) // Adjusted the key to 'files'
          formData.append('name', file.name)
        }
      })
      formData.append('scenario_id', interimScenarioId.toString())
      formData.append('user_id', sessionStorage.getItem('user_id'))
      let config = {
        withCredentials: true,
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      // need to call the service here as Cookie was not getting passed
      const baseURL = process.env.REACT_APP_BASE_API_URL
      let url = `${baseURL}/scenario/uploadScenarioAttachment`
      axios
        .post(url, formData, { ...config })
        .then((resp) => {
          if (resp?.status == 200) {
            pushNotification(
              'success',
              'Data saved successfully!',
              `Attachment saved successfully.`,
              3
            )
            setEnableAttachmentSaveButton(false)
            dispatch(setIsScenarioChangesDetectedFlag(true))
          }
        })
        .catch((err) => {
          if (err.response.status === 401 || err.response.status === 403) {
            pushNotification(
              'error',
              'Error saving data!',
              `Error saving data, please try again.`,
              3
            )
            setEnableAttachmentSaveButton(true)
          }
        })
      // mutateAttachmentData(formData)
      setSaveAttachment(false)
    }
  }, [saveAttachment, attachments, interimScenarioId])
  useEffect(() => {
    if (getNotesApiData?.data?.result) {
      dispatch(updateAddNotes(getNotesApiData.data.result.notes))
      // setEnableTextArea(true);
      // setNotesSaved(true)
    }
  }, [getNotesApiData?.data?.result])

  useEffect(() => {
    dispatch(addAttachment([]))
    if (getAttachmentApiData?.data?.result) {
      dispatch(addAttachment(getAttachmentApiData.data.result))

      setsaved(getAttachmentApiData.data.result)
    }
  }, [getAttachmentApiData?.data?.result])

  useEffect(() => {
    setNotesData(addNotes || '')
    SetEnableEditButton(true)
    // setNotesSaved(!!addNotes);
  }, [addNotes])

  const handleSave = () => {
    dispatch(updateAddNotes(notesData))
    pushNotification('success', 'Data saved successfully!', `Notes saved successfully.`, 3)
    setNotesSaved(true)
    setEnableTextArea(false)
    SetEnableEditButton(true)
  }

  const showDeleteModal = () => {
    setDeleteNotesModalVisible(true)
  }

  const showAttachmentDeleteModal = (index, val) => {
    setIndexx(index)
    setDeleteFile(val)
    setDeleteModalVisible(true)
  }

  const handleDelete = () => {
    dispatch(updateAddNotes(''))
    setNotesData('')
    setNotesSaved(false)
    setEnableTextArea(false)
    setDeleteNotesModalVisible(false)
    pushNotification('success', 'Data deleted successfully!', `Note deleted successfully.`, 3)
    dispatch(setIsScenarioChangesDetectedFlag(true))
    setEnableAttachmentSaveButton(true)
  }

  const handleFileChange = (event) => {
    // Check if the selected file already exists in the attachments
    if (attachments.length) {
      const fileNames = attachments.map((file) => file.name ?? file.file_name)
      const newFiles = Array.from(event.target.files).filter(
        (file) => !fileNames.includes(file.name)
      )
      if (newFiles.length === 0) {
        pushNotification(
          'error',
          'Duplicate File(s) Uploaded!',
          `File already exists, please try again with a different file.`,
          5
        )
        return
      }
    }
    setEnableAttachmentSaveButton(true)
    dispatch(setIsScenarioChangesDetectedFlag(true))
    event.preventDefault()
    const files = Array.from(event.target.files)

    const validFiles = files.filter((file) => {
      const isValidType = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/csv',
        'application/vnd.ms-excel',
        'text/plain',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      ].includes(file.type)
      const isValidSize = file.size <= 20 * 1024 * 1024
      return isValidType && isValidSize
    })

    if (validFiles.length < files.length) {
      pushNotification(
        'error',
        'Invalid File(s) Uploaded!',
        `Some files were not added. Only CSV, Word, PDF, TXT, XLSX, and PPT files under 20MB are allowed.`,
        5
      )
    }
    validFiles.forEach((file) => dispatch(addAttachment(file)))
    // Reset the input value after processing
    event.target.value = null
  }

  const handleDeleteAttachment = () => {
    // console.log("index: ", indexx,deletefile.name ?? deletefile?.file_name ,deletefile?.file_name)
    dispatch(deleteAttachment(indexx))
    dispatch(updateDeletedFiles(deletefile.name ?? deletefile?.file_name))
    setDeleteModalVisible(false)
    setEnableAttachmentSaveButton(true)
    pushNotification('success', 'Data deleted successfully!', `Attachment deleted successfully.`, 3)
    dispatch(setIsScenarioChangesDetectedFlag(true))
  }
  // const handleDownloadAttachment = (file) => {
  //   // window.open(file.link);
  //   const url = URL.createObjectURL(file);
  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = file.name ??  file.file_name;
  //   a.click();
  //   URL.revokeObjectURL(url);
  //   setShowNotification(true);
  //   setNotificationType("success");
  //   setNotificationMessage("Data downloaded successfully!");
  //   setNotificationDescription(
  //     "Attachment downloaded successfully."
  //   );
  //   setTimeout(() => {
  //     setShowNotification(false);
  //   }, 3000);
  // };

  const handleDownloadAttachment = async (file) => {
    try {
      let fileData

      if (file instanceof Blob || file instanceof File) {
        fileData = file
      } else if (file.link) {
        const response = await fetch(file.link)
        if (!response.ok) throw new Error('Failed to fetch file')
        fileData = await response.blob()
      } else {
        throw new Error('Invalid file object')
      }

      const url = URL.createObjectURL(fileData)
      const a = document.createElement('a')
      a.href = url
      a.download = file.name ?? file.file_name
      a.click()
      URL.revokeObjectURL(url)
      pushNotification(
        'success',
        'Data downloaded successfully!',
        `Attachment downloaded successfully.`,
        3
      )
    } catch (error) {
      // console.error("Download failed:", error);
      pushNotification('error', 'Download failed!', `There was an issue downloading the file.`, 3)
    }
  }

  return (
    <>
      <div className="notes-section">
        <Row style={{ marginBottom: -15 }}>
          <Col className="col-notes-section">
            <div
              className="notes-section-1"
              style={{ width: '100%', display: 'flex', gap: 35, padding: '0 15px' }}
            >
              <div className="note-section-1-header" style={{ gap: 30 }}>
                <div className="date-text-Scenerio">
                  <b>Scenario Type:</b> {'  '}
                  {scenarioType}
                </div>
              </div>
              <div className="note-section-1-header" style={{ gap: 40, padding: 0, margin: 0 }}>
                <img alt={'Icon'} src={Vector_20} />
                <div className="date-text-Scenerio">
                  <b>Data Source:</b> {'  '}
                  {dataSourceForScenario}
                </div>
              </div>
              <div className="note-section-1-header" style={{ gap: 30 }}>
                <img alt={'Icon'} src={Vector_20} />
                <div className="date-text-Scenerio">
                  <b>Status:</b> {'  '}
                  {scenarioStatus}
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="col-notes-section">
            <div className="notes-section-1">
              <div className="note-section-1-header">
                <span className="Text-note">Notes</span>
              </div>
              <div>
                <>
                  <TextArea
                    style={{
                      minHeight: '248px',
                      backgroundColor: enableTextArea ? '#ffffff' : '#f5f5f5'
                    }}
                    rows={4}
                    onFocus={() => {
                      setEnableTextArea(true)
                    }}
                    onBlur={() => {
                      setEnableTextArea(false)
                    }}
                    placeholder="Start Writing your text here"
                    value={notesData}
                    onChange={(event) => setNotesData(event.target.value)}
                  />
                  <div className="button-container">
                    <Button
                      className="button-notes"
                      onClick={handleSave}
                      disabled={notesData.trim() === '' || notesSaved}
                      style={{ backgroundColor: '#00857C', color: '#ffffff' }}
                    >
                      Save
                    </Button>
                  </div>
                </>
              </div>
            </div>
            <div
              className="attachment-section-2"
              style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}
            >
              <div className="attachment-section-2-header">
                <span className="Text-note">Attachments</span>
                <input
                  type="file"
                  multiple
                  onChange={(event) => {
                    handleFileChange(event)
                    event.target.value = null // Reset the input value to ensure onChange triggers
                  }}
                  style={{ display: 'none' }}
                  id="fileInput"
                />
                <Button
                  className="button-note"
                  onClick={() => document.getElementById('fileInput').click()}
                >
                  + Add Attachment
                </Button>
              </div>
              {/* <hr /> */}
              <div
                className="attachment-list"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: '1',
                  maxHeight: '232px',
                  // overflowY: attachments.length > 4 ? "scroll" : "visible",
                  overflowY: 'auto',
                  backgroundColor: '#f9f9f9',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  transition: 'all 0.3s ease',

                  scrollbarWidth: 'thin',
                  scrollbarColor: '#888 #f9f9f9',

                  '&::-webkit-scrollbar': {
                    width: '6px'
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888',
                    borderRadius: '10px'
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#555'
                  },

                  '@media (max-width: 768px)': {
                    maxHeight: '180px',
                    padding: '8px 12px'
                  }
                }}
              >
                {attachments.length === 0 ? (
                  <span>Start adding your Attachment here</span>
                ) : (
                  attachments.map((file, index) => (
                    <div key={index} className="attachment-item">
                      <span>
                        {index + 1}. {file.name ?? file?.file_name}
                      </span>
                      <div className="attchment-actions">
                        <Button
                          className="button-note"
                          onClick={() => handleDownloadAttachment(file)}
                        >
                          <DownloadOutlined />
                        </Button>
                        <Button
                          className="button-note"
                          onClick={() => showAttachmentDeleteModal(index, file)}
                        >
                          <DeleteOutlined />
                        </Button>
                      </div>
                    </div>
                  ))
                )}
              </div>
              <div className="button-container" style={{ paddingTop: '16px', marginTop: 'auto' }}>
                <Button
                  onClick={() => setSaveAttachment(true)}
                  style={{ backgroundColor: '#00857C', color: '#ffffff' }}
                  disabled={!enableAttachmentSaveButton || attachments.length === 0}
                >
                  Save
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <Modal
        title={`Delete Note`}
        className="delete-modal"
        open={deleteNotesVisible}
        onOk={handleDelete}
        okText="Delete"
        destroyOnClose={true}
        onCancel={() => {
          setDeleteNotesModalVisible(false)
        }}
      >
        <div
          style={{
            backgroundColor: '#ffffff',
            padding: '16px',
            paddingBottom: '24px',
            border: '1px solid #e1e9ef',
            borderBottom: '0px'
          }}
        >
          <span style={{ color: '#000000', fontWeight: '600' }}>
            Are you sure you want to delete this note?
          </span>
        </div>
      </Modal>
      <Modal
        title={`Delete Attachment`}
        className="delete-modal"
        open={deleteModalVisible}
        onOk={handleDeleteAttachment}
        okText="Delete"
        destroyOnClose={true}
        onCancel={() => {
          setDeleteModalVisible(false)
        }}
      >
        <div
          style={{
            backgroundColor: '#ffffff',
            padding: '16px',
            paddingBottom: '24px',
            border: '1px solid #e1e9ef',
            borderBottom: '0px'
          }}
        >
          <span style={{ color: '#000000', fontWeight: '600' }}>
            Are you sure you want to delete this attachment ?
          </span>
        </div>
      </Modal>
    </>
  )
}

export default NotesAttachment
